const SECTION_START = /\n(?=## \d+\.)/;
const sectionNumberOf = (section: string): number | null => {
  const match = section.match(/^## (\d+)\./);
  return match ? Number(match[1]) : null;
};

export const briefSection = (brief: string, section: number): string | undefined =>
  brief.split(SECTION_START).find((part) => sectionNumberOf(part) === section);

// Section 1, Sections 2-7, or the listed section numbers.
export type TBriefSections = "decision" | "afterDecision" | number[];

// Takes only the given sections from `source` and keeps the rest of `target`. Writes to different
// sections come from different requests whose replies can arrive out of order; taking just the
// sections a write changed keeps a late reply from putting back an older copy of the others.
export function withSectionsFrom(target: string, source: string, sections: TBriefSections): string {
  const wanted = (number: number | null) => {
    if (number === null) return false;
    if (Array.isArray(sections)) return sections.includes(number);
    return sections === "decision" ? number === 1 : number > 1;
  };
  const fromSource = new Map<number, string>();
  source.split(SECTION_START).forEach((part) => {
    const number = sectionNumberOf(part);
    if (number !== null && wanted(number)) fromSource.set(number, part);
  });
  return target
    .split(SECTION_START)
    .map((part) => {
      const number = sectionNumberOf(part);
      return number !== null && fromSource.has(number) ? (fromSource.get(number) as string) : part;
    })
    .join("\n");
}
